module.exports = __webpack_public_path__ + "static/media/cinema.ac47b54a.jpg";